// Feature: M001-D022-F004
// Test: T-APPAPI-020

export const resolveAppAccess = (globalDefault, organisationValue = null, userValue = null) => {
  if (userValue !== null && userValue !== undefined) {
    return { allowed: userValue === true, source: 'user organisation' };
  }
  if (organisationValue !== null && organisationValue !== undefined) {
    return { allowed: organisationValue === true, source: 'organisation role' };
  }
  if (globalDefault !== null && globalDefault !== undefined) {
    return { allowed: globalDefault === true, source: 'global role' };
  }
  return { allowed: false, source: 'default deny' };
};

export const appAccessSelectValue = (value) => (
  value === null || value === undefined ? 'inherit' : (value ? 'allow' : 'deny')
);

